const isHappyDance = (organizationName?: string) => (
  ["happy dance"].includes(organizationName?.toLowerCase() || "")
);

export default isHappyDance;
